import React, { Component } from 'react';
import { ToggleSmall, Modal, RadioButtonGroup, RadioButton, Checkbox } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Breadcrumb, Card } from '../../../../components';
import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      name: '',
      openMdDelete: false,
      unique: false,
      fractioned: false,
      sequential: false,
      complement: false
    };
  }

  componentWillMount() {
    this.getItem();
  }

  getItem = async () => {
    const { match } = this.props;
    const urlId = match.params && match.params.id;
    const result = await getByDmService('/Aplicacao', urlId);  
    const {ativo, exigeComplemento, fracionado, nome, sequencial, unico} = result;

    this.setState({
      active: ativo,
      name: nome,
      complement: exigeComplemento,
      fractioned: fracionado,
      sequential: sequencial,
      unique: unico
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { active, unique, fractioned, sequential, complement, name } = this.state;
    const urlId = match.params && match.params.id;
    this.setState(
      prevState => ({
        active: !prevState.active
      }),
      async () => {
        const formData = {
          nome: name,
          ExigeComplemento: complement,
          Unico: unique,
          Fracionado: fractioned,
          Sequencial: sequential,
          ativo: !active
        };
        try {
          await updateDmService(`/Aplicacao/`, urlId, formData);
        } catch (error) {
          this.setState(prevState => ({active: prevState.active}));
          toast.warn("Ocorreu uma falha ao tentar atualizar o status");
        }

        
      }
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  changeComplement = event => {
    console.log("change complement")
    console.log(event)
    const mark = true;
    const radioMark = event === 'default-selected-yes' ? mark : false
    this.setState({
      complement: radioMark
    });
  }

  onChangeCheckedVariable = (event, check) => {
  
    if(check === 'unique'){
      this.setState({unique: event})
    }else if(check === 'fractioned'){
      this.setState({fractioned: event})
    }else{
      this.setState({sequential: event})
    }

  }

  saveAplicacao = async e => {
    e.preventDefault();
    const { name, complement, unique, fractioned, sequential } = this.state;
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/Aplicacao/`;

    const formData = {
      nome: name,
      ExigeComplemento: complement,
      Unico: unique,
      Fracionado: fractioned,
      Sequencial: sequential
    };

    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);        
        toast.success('Edição realizada com sucesso.');        
      } else {
        await insertDmService(urlEdit, formData);
        toast.success('Categoria salva com sucesso.');
      }

      history.goBack()

    } catch (error) {
      toast.warn(
        'Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados'
      );
    }
  };


  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete
    }));
  }


  delete = async () => {
    const {match, history} = this.props;
    const urlId = match.params && match.params.id;
    
    try {
      await deleteDmService("/Aplicacao", urlId);
      toast.success("Deletado conforme o solicitado.");      
      history.goBack();
    } catch (error) {
      toast.error("Um erro inesperado ocorreu ao tentar deletar");
    }    
  }


  render() {
    const {
      active,
      name,
      openMdDelete,
      unique,
      fractioned,
      sequential,
      complement
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;
    const titleBread ='Editar Aplicação';
    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title={titleBread}
            description="Gerencie aplicações de produtos agência."
            renderRight={(() => (
              <div className="flex v-sm-margin">
                <label
                  htmlFor="toogle-active"
                  className={`${
                    active ? 'text-info ' : 'text-warning'
                  } label-toogle-active`}
                >
                  {active ? 'Ativo' : 'Inativo'}
                </label>
                <ToggleSmall
                  id="toogle-active"
                  className="toogle-active"
                  toggled={active}
                  ariaLabel="Ativo"
                  onClick={() => this.onToogle()}
                />
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  type="button"
                  onClick={() => this.modalDelete()}
                >
                  Remover
                </button>
              </div>
            ))()}
            renderLeft={(() => (
              <div
                className="breadcrumb-left-actions pointer"
                onClick={() => history.goBack()}
              >
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title={titleBread}
            description="Gerencie grupos de produtos agência."
            renderLeft={(() => (
              <div
                className="breadcrumb-left-actions pointer"
                onClick={() => history.goBack()}
              >
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form
            onSubmit={this.saveAplicacao}
          >
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">Nome da aplicação</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Digite aqui o nome da aplicação"
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">Exige complemento?</label>
                <RadioButtonGroup
                  defaultSelected={complement ? 'default-selected-yes' : 'default-selected-no'}
                  legend="Group Legend"
                  name="radio-button-group"
                  valueSelected={complement ? 'default-selected-yes' : 'default-selected-no'}
                  onChange={e => this.changeComplement(e)}
                >
                  <RadioButton
                    value="default-selected-yes"
                    id="radio-1"
                    className="some-class"
                    disabled={false}
                    labelText="Sim"
                  />
                  <RadioButton
                    value="default-selected-no"
                    id="radio-2"
                    className="some-class"
                    disabled={false}
                    labelText="Não"
                    
                  />
                </RadioButtonGroup>
              </div>
            </div> 
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 v-md-margin">
                <label className="bx--label v-md-margin">Variáveis de aplicação</label>
                <div className="bx--row">
                  <div className="bx--col-xs-6 bx--col-md-1">
                    <Checkbox
                      labelText="Único"
                      id="check-unico"
                      name="unico-check"
                      defaultChecked={unique}
                      checked={unique}
                      onChange={e => this.onChangeCheckedVariable(e, 'unique')}
                    />
                  </div>
                  <div className="bx--col-xs-6 bx--col-md-1">
                    <Checkbox
                      labelText="Fracionado"
                      id="check-fracionado"
                      name="unico-check"
                      defaultChecked={fractioned}
                      checked={fractioned}
                      onChange={e => this.onChangeCheckedVariable(e, 'fractioned')}
                    />
                  </div>
                  <div className="bx--col-xs-6 bx--col-md-1">
                    <Checkbox
                      labelText="Sequencial"
                      id="check-sequencial"
                      name="unico-check"
                      checked={sequential}
                      defaultChecked={sequential}
                      onChange={e => this.onChangeCheckedVariable(e, 'sequential')}
                    />
                  </div>                                    
                </div>                                         
              </div>
            </div>           
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 v-md-margin ">
                <button
                  tabIndex="0"
                  className="bx--btn btn-secondary-color"
                  type="submit"
                >
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fechar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}          
        >
          <p className="bx--modal-content__text">
            Você tem certeza que deseja deletar este item?
          </p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManagementApplication/Edit.js